import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { LoadingService } from '@app/core/services/loading.service';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-global-loader',
  standalone: true,
  imports: [CommonModule, NzSpinModule],
  template: `
    <ng-container *ngIf="loading$ | async as isLoading">
      <div *ngIf="isLoading" class="box-container">
      </div>
    </ng-container>
  `,
  styles: [`
    .box-container{
    height: 100vh;
    width: 100%;
    position: fixed;
    background: #ffffff7d;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1111;
}
  `]
})
export class GlobalLoaderComponent implements OnInit, OnDestroy {
  loading$ = this.loadingService.loading$.pipe(
    tap(loading => console.log('GlobalLoaderComponent - Loading state changed:', loading))
  );
  private subscription?: Subscription;

  constructor(private loadingService: LoadingService) {
    console.log('GlobalLoaderComponent constructor - LoadingService injected');
    console.log('Initial loading state:', this.loadingService.loading$);
  }

  ngOnInit(): void {
    console.log('GlobalLoaderComponent ngOnInit');
  }

  ngOnDestroy(): void {
    console.log('GlobalLoaderComponent destroyed');
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
